import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const NightSetbackGlyph = /*#__PURE__*/createElement("g", {
  id: "night_setback"
}, /*#__PURE__*/createElement("path", {
  d: "M54.08 42.05c0-12-9.6-21.8-21.6-22-.2 0-.2.1-.1.2 11.7 12.1 11.7 31.4-.1 43.6-.1.1-.1.2.1.2 12.1-.2 21.7-10 21.7-22m-25.8 24.7c-1.3-.2-1.7-1.8-.7-2.7 14.1-11.3 14.1-32.8 0-44.1-1-.8-.6-2.5.7-2.7 15.1-2.3 28.7 9.4 28.7 24.7 0 15.4-13.6 27.1-28.7 24.8"
}));
const NightSetback = createSvg({
  name: 'night_setback',
  path: NightSetbackGlyph
});

export default NightSetback;
export { NightSetbackGlyph };
